'use client'

import textDisplayXL from '@fukku/styles/texts/textDisplayXL.module.css'
import textInspirationalTitleXXL from '@fukku/styles/texts/textInspirationalTitleXXL.module.css'
import textInspirationalTitleXXXL from '@fukku/styles/texts/textInspirationalTitleXXXL.module.css'
import cx from 'classix'
import { useRef } from 'react'
import { HERO_BANNER_SHOP_PLUS_TITLE_TYPE } from 'services/graphql/contentStack/homes/query.type'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import { useTextOverflow } from '../../../../../../../hooks/useTextOverflow/useTextOverflow'
import animationStyles from '../../../../MotionAnimations.module.css'
import styles from './HeroBannerShopTitle.module.css'

interface HeroBannerShopTitleProps {
	readonly titleType: HERO_BANNER_SHOP_PLUS_TITLE_TYPE | null
	readonly titleKey: string | null
	readonly titleKeyLanguage: string | null
	readonly inverse: boolean
	readonly isLargeOrGreater: boolean
}

const textClassName = (
	titleType: HERO_BANNER_SHOP_PLUS_TITLE_TYPE | null,
	isLargeOrGreater: boolean
) => {
	if (titleType === HERO_BANNER_SHOP_PLUS_TITLE_TYPE.MANGO_SANS) {
		return textDisplayXL.className
	}

	return isLargeOrGreater
		? textInspirationalTitleXXXL.className
		: textInspirationalTitleXXL.className
}

export function HeroBannerShopTitle({
	titleType,
	titleKey,
	titleKeyLanguage,
	inverse,
	isLargeOrGreater,
}: HeroBannerShopTitleProps) {
	const titleRef = useRef(null)
	const isTextOverflowing = useTextOverflow(titleRef)

	return (
		<h2
			ref={titleRef}
			className={cx(
				animationStyles.opacityFadeIn,
				styles.heroBannerShopTitle,
				applyStylesIf(inverse, styles.inverse),
				textClassName(titleType, isLargeOrGreater),
				applyStylesIf(isTextOverflowing, styles.breakWord)
			)}
			lang={titleKeyLanguage ?? undefined}
		>
			{titleKey}
		</h2>
	)
}
